import { EVENT_KEYS as OPTIMIZELY_EVENTS } from '../../../lib/optimizely';

export const BROWSE_CLICK = {
  eventAction: 'browseClick',
  getEventData: (tile: string) => ({
    eventLabel: `browseCategory=allMakes;tile=${tile}`,
  }),
  optimizelyEvents: [OPTIMIZELY_EVENTS.RESULTS_SEARCH],
};
